// amplifyConfig.js
import { Amplify } from 'aws-amplify';
import environment from './configEnv';

export const configureAmplify = () => {
  console.log(environment);
  Amplify.configure({
    Auth: {
      region: environment.region,
      userPoolId: environment.userPoolId,
      userPoolWebClientId: environment.userPoolWebClientId,
    },
  });
};
